// styles
import styled from 'styled-components';

const SoFormPanelText = styled.h3`
  height: 24px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--grey800);
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export default SoFormPanelText;
